import { log } from 'log';
import { useEffect } from 'react';
import { get } from 'js/utils/fetch.util';
import { useDispatch } from 'react-redux';
import { integrationScriptLoadState } from 'js/hooks/auth/pas';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

import * as actions from '../store/actions';

export const useGetMaintenanceData = (): void => {
    // todo should be improved by COR18-12909
    const requestStamp = window.Playtech.Variables.requestStamp || Date.now();
    const dispatch = useDispatch();
    const getCMSResourceURL = useGetCMSResourceURL();

    useEffect(() => {
        (async () => {
            try {
                const response = await get(getCMSResourceURL('/initialResources/maintenance', { t: requestStamp }));

                dispatch(actions.setMaintenanceDataAction(response));
            } catch {
                dispatch(actions.setIsLoadingAction(false));

                log('unable to fetch maintenance mode data');
            }

            try {
                await integrationScriptLoadState;
            } catch {
                dispatch(actions.setIsIntegrationScriptFailedAction(true));
            }
        })();
    }, [dispatch, requestStamp, getCMSResourceURL]);
};
